// extracted by mini-css-extract-plugin
module.exports = {"root":"NonDupPatients_root__6p83q"};